<!-- <pre style="position: fixed; right: 0; bottom: 0; opacity: 0.7; max-height: 500px; overflow: auto; z-index: 100; color: green; background-color: black;">
    {{hierarchyTable.tableRow |json}}
    {{engagementService.getDrilldownHistory()|json}}
</pre> -->
<div [class.fullscreen]="fullScreenLeftBox">
    <div class="engagement-hierarchy-summary" [id]="componentId">
        <div class="engagement-hierarchy-summary-top-panel">
            <div class="engagement-hierarchy-summary-header">
                <div>
                    <span class="ltms-widget-title">
                        {{ title }}
                    </span><br>
                    <span class="engagement-hierarchy-summary-top-panel-discription ltms-description">
                        {{ discription }}
                    </span>
                </div>
                <div class="engagement-hierarchy-summary-tools">
                    <div class="filter-text">View by</div>
                    <app-score-dropdown-menu [config]="viewTypeDropdown.config"
                        [selectedOption]="viewTypeDropdown['selectedOption']" [options]="viewTypeDropdown.options"
                        (selectedOptionChange)="onFilterChange($event)"></app-score-dropdown-menu>
                    <div class="engagement-widget-container">
                        <app-score-widget [config]="scoreWidget('drilldown')" (onDownloadClick)="onDownload()"
                            (onFullscreenClick)="onFullscreenLeftBox($event, 'drillDownTable')"></app-score-widget>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="isDataLoaded == true" style="width: 100%;">
            <div class="engagement-hierarchy-table-container" [id]="containerId">
        
                <app-score-table [tableColumns]="overallSummaryTable.tableHeader" (onTextClickCall)="resetHierarchData()"
                    [tableData]="overallSummaryTable.tableRow" [showDeviation]="isDeviationEnabled"
                    [tablePlugins]="overallSummaryTable.tablePlugins"
                    [deviationComparisonLabel]="deviationComparisonLabel">
                </app-score-table>
        
                <div class="engagement-hierarchy-summary-drilldown scroll-wrapper">
                    <div class="scroll-content" *ngIf="subAccountTable.tableRow.length">
                        <app-score-table [tableColumns]="subAccountTable.tableHeader" (onDrillDownClick)="onDrillDown($event)"
                            (onTextClickCall)="updateSubAccountData($event)" [tableData]="subAccountTable.tableRow" [showDeviation]="isDeviationEnabled"
                            [tablePlugins]="overallSummaryTable.tablePlugins"
                            [deviationComparisonLabel]="deviationComparisonLabel">
                        </app-score-table>
                    </div>
                    <div class="scroll-content" *ngIf="!isHierarchyTableHidden">
                        @if (isHieararchyTableLoaded){
                            <app-score-table [tableColumns]="hierarchyTable.tableHeader" (onDrillDownClick)="onDrillDown($event)"
                                (onTextClickCall)="onDrillDown($event)" [tableData]="hierarchyTable.tableRow" [showDeviation]="isDeviationEnabled"
                                [tablePlugins]="overallSummaryTable.tablePlugins"
                                [deviationComparisonLabel]="deviationComparisonLabel">
                            </app-score-table>
                        } @else {
                            <div class="data-details-loader">
                                <app-ltms-loader></app-ltms-loader>
                            </div>
                        }
                    </div>
                </div>
        
            </div>
        </div>
        <!-- <div *ngIf="!isDataAvailable && isDataLoaded == true">
            <app-ltms-error [code]="errorCode"></app-ltms-error>
        </div> -->
        <div class="data-details-loader" *ngIf="isDataLoaded == false">
            <app-ltms-loader></app-ltms-loader>
        </div>
    </div>
</div>